import { useMutation, useQueryClient } from '@tanstack/react-query';
import { alertError, alertSuccess } from 'src/libs/toastify';
import { addWarehouseIncome } from '../services';

const Message = {
  ADD_SUCCESS: 'Акт приёмки успешно создан',
  ADD_ERROR: 'Ошибка создания акта приёмки',
};

export const useWarehouseIncomesActions = () => {
  const client = useQueryClient();

  const onSuccessHandler = (successMessage?: string) => {
    client.invalidateQueries({ queryKey: ['warehouse-incomes'], exact: false });
    if (successMessage) alertSuccess(successMessage);
  };

  const addMutation = useMutation(addWarehouseIncome, {
    onSuccess: () => onSuccessHandler(Message.ADD_SUCCESS),
    onError: (error) => alertError(error, Message.ADD_ERROR),
  });

  return {
    addWarehouseIncome: addMutation,
  };
};
